import { inject, observer } from "mobx-react";
import { useEffect } from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Link,
} from "@mui/material";

// import "./reference.css";
import "./reference_new.scss";

function Ref(data) {
  return (
    // <Container className="ref-body"  maxWidth="xl">
    <Grid container spacing={2}>
      <Grid
        item
        md={12}
        sm={12}
        xs={12}
        container
        direction="column"
        spacing={4}
      >
        <Grid item>
          <CardContent sx={{ ml: 2 }}>
            <Card sx={{ minWidth: 300, borderLeft: "6px solid #f6903d" }}>
              <CardContent sx={{ ml: 2 }}>
                <Typography
                  variant="h3"
                  component="div"
                  color="#35c090"
                  sx={{ fontSize: "25px", fontWeight: "bold", mb: 1, mt: 3 }}
                >
                  <Link
                    href={data.link}
                    underline="none"
                    sx={{ color: "black" }}
                  >
                    {data.name}
                  </Link>
                </Typography>
                <Typography
                  variant="h5"
                  color="primary"
                  component="div"
                  className="info-label"
                  sx={{ color: "black", fontSize: "18px", mb: 1, mt: 2 }}
                >
                  {data.author}
                </Typography>
                <Grid item>
                  <Typography
                    variant="p"
                    color="primary"
                    component="div"
                    className="info-label"
                    sx={{ color: "black", fontSize: "18px" }}
                  >
                    <p>
                      <i>{data.book}</i> {data.doi}
                    </p>
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography
                    variant="p"
                    color="primary"
                    component="div"
                    className="info-label"
                    sx={{ color: "black" }}
                  >
                    <p>
                      [
                      <Link
                        href={data.link}
                        sx={{
                          fontSize: "16px",
                          color: "#1890ff",
                          cursor: "pointer",
                        }}
                      >
                        Full Text
                      </Link>
                      ] [
                      <Link
                        href={data.PDF}
                        sx={{
                          fontSize: "16px",
                          color: "#1890ff",
                          cursor: "pointer",
                        }}
                      >
                        PDF
                      </Link>
                      ]
                    </p>
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </CardContent>
        </Grid>
      </Grid>
    </Grid>
    // </Container>
  );
}
//name  link author book doi PDF
function Reference(store) {
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);
  return (
    <Container className="ref-body" maxWidth="xl">
      <Box className="ref-title" color="primary.light">
        <Typography variant="h3" component="div" className="ref-title-text">
          Reference
        </Typography>
      </Box>

      <Ref
        name="Bidirectional LSTM-CRF Models for Sequence Tagging"
        link="https://arxiv.org/abs/1508.01991"
        author="Zhiheng Huang, Wei Xu, Kai Yu"
        book="arXiv"
        doi="1508.01991"
        PDF="https://arxiv.org/pdf/1508.01991"
      ></Ref>
      <Ref
        name="Attention-based LSTM for Aspect-level Sentiment Classification"
        link="https://aclanthology.org/D16-1058/"
        author="Yequan Wang, Minlie Huang, Xiaoyan Zhu, Li Zhao"
        book="EMNLP"
        doi="10.18653/v1/D16-1058"
        PDF="https://aclanthology.org/D16-1058.pdf"
      ></Ref>
      <Ref
        name="Very Deep Convolutional Networks for Large-Scale Image Recognition"
        link="https://arxiv.org/abs/1409.1556"
        author="Karen Simonyan, Andrew Zisserman"
        book="arXiv"
        doi="1409.1556"
        PDF="https://arxiv.org/pdf/1409.1556"
      ></Ref>
      <Ref
        name="On the Properties of Neural Machine Translation: Encoder-Decoder Approaches"
        link="https://arxiv.org/abs/1409.1259"
        author="Cho, Kyunghyun; van Merrienboer, Bart; Bahdanau, DZmitry; Bengio, Yoshua "
        book="arXiv"
        doi="1409.1259"
        PDF="https://arxiv.org/pdf/1409.1259"
      ></Ref>
      <Ref
        name="Convolutional Neural Networks for Sentence Classification"
        link="https://arxiv.org/abs/1408.5882"
        author="Yoon Kim"
        book="arXiv"
        doi="1408.5882"
        PDF="https://arxiv.org/pdf/1408.5882"
      ></Ref>
      <Ref
        name="Recurrent Convolutional Neural Networks for Text Classification"
        link=""
        author=""
        book="AAAI2015"
        doi="10.5555/2886521.2886636"
        PDF="http://www.nlpr.ia.ac.cn/cip/~liukang/liukangPageFile/Recurrent%20Convolutional%20Neural%20Networks%20for%20Text%20Classification.pdf"
      ></Ref>
      <Ref
        name="Attention Is All You Need"
        link="https://arxiv.org/abs/1706.03762"
        author="Ashish Vaswani, Noam Shazeer, Niki Parmar, Jakob Uszkoreit, Llion Jones, Aidan N. Gomez, Lukasz Kaiser, Illia Polosukhin"
        book="arXiv "
        doi="1706.03762 "
        PDF="https://arxiv.org/pdf/1706.03762"
      ></Ref>
      <Ref
        name="ReFormer: The Relational Transformer for Image Captioning"
        link="https://arxiv.org/abs/2107.14178"
        author="Xuewen Yang, Yingru Liu, Xin Wang"
        book=" arXi"
        doi="2107.14178v1"
        PDF="https://arxiv.org/pdf/2107.14178"
      ></Ref>
      <Ref
        name="Rethinking attention with performers."
        link="https://arxiv.org/abs/2009.14794"
        author="Krzysztof Choromanski, Valerii Likhosherstov, David Dohan, Xingyou Song, Andreea Gane, Tamas Sarlos, Peter Hawkins, Jared Davis, Afroz Mohiuddin, Lukasz Kaiser, David Belanger, Lucy Colwell, Adrian Weller"
        book="arXiv "
        doi="2009.14794 "
        PDF="https://arxiv.org/pdf/2009.14794"
      ></Ref>
      <Ref
        name="Linformer: Self-Attention with Linear Complexity"
        link="https://arxiv.org/abs/2006.04768"
        author="Sinong Wang, Belinda Z. Li, Madian Khabsa, Han Fang, Hao Ma"
        book="arXiv"
        doi="2006.04768"
        PDF="https://arxiv.org/pdf/2006.04768"
      ></Ref>
      <Ref
        name="Efficient Content-Based Sparse Attention with Routing Transformers"
        link="https://aclanthology.org/2021.tacl-1.4/"
        author="Aurko Roy, Mohammad Saffar, Ashish Vaswani, David Grangier"
        book="ACL"
        doi="10.1162/tacl_a_00353"
        PDF="https://aclanthology.org/2021.tacl-1.4.pdf"
      ></Ref>
      <Ref
        name="DNABERT: pre-trained Bidirectional Encoder Representations from Transformers model for DNA-language in genome"
        link="https://academic.oup.com/bioinformatics/article-abstract/37/15/2112/6128680?redirectedFrom=fulltext"
        author="Yanrong Ji, Zhihan Zhou, Han Liu, Ramana V Davuluri"
        book="Bioinformatics"
        doi="10.1093/bioinformatics/btab083"
        PDF="https://www.biorxiv.org/content/10.1101/2020.09.17.301879v1.full.pdf"
      ></Ref>
      <Ref
        name="ProtTrans: towards cracking the language of Life's code through self-supervised deep learning and high performance computing."
        link="https://arxiv.org/abs/2007.06225"
        author="Ahmed Elnaggar, Michael Heinzinger, Christian Dallago, Ghalia Rihawi, Yu Wang, Llion Jones, Tom Gibbs, Tamas Feher, Christoph Angerer, Martin Steinegger, Debsindhu Bhowmik, Burkhard Rost"
        book="arXiv"
        doi="2007.06225"
        PDF="https://arxiv.org/pdf/2007.06225"
      ></Ref>
      <Ref
        name="BERT: Pre-training of Deep Bidirectional Transformers for Language Understanding"
        link="https://arxiv.org/abs/1810.04805"
        author="Jacob Devlin, Ming-Wei Chang, Kenton Lee, Kristina Toutanova"
        book="arXiv"
        doi="1810.04805"
        PDF="https://arxiv.org/pdf/1810.04805"
      ></Ref>
      <Ref
        name="KUISAIL at SemEval-2020 Task 12: BERT-CNN for Offensive Speech Identification in Social Media"
        link="https://arxiv.org/abs/2007.13184"
        author="Ali Safaya, Moutasem Abdullatif, Deniz Yuret"
        book="arXiv:2007.13184"
        doi=""
        PDF="https://arxiv.org/pdf/2007.13184"
      ></Ref>
      <Ref
        name="Microblog Rumor Detection Based on Bert-DPCNN"
        link="https://link.springer.com/chapter/10.1007/978-981-15-8599-9_60"
        author="Yan-Jun Li, Hai-Jun Zhang, Wei-Min Pan, Ru-Jia Feng & Zhong-Yue Zhou "
        book="Artificial Intelligence in China"
        doi=""
        PDF="https://link.springer.com/content/pdf/10.1007/978-981-15-8599-9.pdf"
      ></Ref>
      <Ref
        name="ERNIE: Enhanced Language Representation with Informative Entities"
        link="https://arxiv.org/abs/1905.07129"
        author="Zhengyan Zhang, Xu Han, Zhiyuan Liu, Xin Jiang, Maosong Sun, Qun Liu"
        book="arXiv:1905.07129 "
        doi=" "
        PDF="https://arxiv.org/pdf/1905.07129"
      ></Ref>
      <Ref
        name="Semi-Supervised Classification with Graph Convolutional Networks"
        link="https://arxiv.org/abs/1609.02907"
        author="Thomas N. Kipf, Max Welling"
        book="arXiv:1609.02907"
        doi=""
        PDF="https://arxiv.org/pdf/1609.02907"
      ></Ref>
      <Ref
        name="Regularized Simple Graph Convolution (SGC) for improved interpretability of large datasets"
        link="https://journalofbigdata.springeropen.com/articles/10.1186/s40537-020-00366-x"
        author="Phuong Pho & Alexander V. Mantzaris "
        book="Journal of Big Data"
        doi=""
        PDF="https://journalofbigdata.springeropen.com/track/pdf/10.1186/s40537-020-00366-x.pdf"
      ></Ref>
      <Ref
        name="BertGCN: Transductive Text Classification by Combining GCN and BERT"
        link="https://arxiv.org/abs/2105.05727"
        author="Yuxiao Lin, Yuxian Meng, Xiaofei Sun, Qinghong Han, Kun Kuang, Jiwei Li, Fei Wu"
        book="arXiv:2105.05727"
        doi=""
        PDF="https://arxiv.org/pdf/2105.05727"
      ></Ref>
      <Ref
        name="Graph Attention Networks"
        link="https://arxiv.org/abs/1710.10903"
        author="Petar Veličković, Guillem Cucurull, Arantxa Casanova, Adriana Romero, Pietro Liò, Yoshua Bengio"
        book="arXiv:1710.10903 "
        doi=" "
        PDF="https://arxiv.org/pdf/1710.10903"
      ></Ref>
      <Ref
        name="How Powerful are Graph Neural Networks?"
        link="https://paperswithcode.com/paper/how-powerful-are-graph-neural-networks"
        author="Keyulu Xu, Weihua Hu, Jure Leskovec, Stefanie Jegelka"
        book="ICLR 2019"
        doi=""
        PDF="https://arxiv.org/pdf/1810.00826v3.pdf"
      ></Ref>
      <Ref
        name="Inductive Representation Learning on Large Graphs"
        link="https://arxiv.org/abs/1706.02216"
        author="William L. Hamilton, Rex Ying, Jure Leskovec"
        book="arXiv:1706.02216"
        doi=""
        PDF="https://arxiv.org/pdf/1706.02216"
      ></Ref>
      <Ref
        name="LightGCN: Simplifying and Powering Graph Convolution Network for Recommendation"
        link="https://arxiv.org/abs/2002.02126"
        author="Xiangnan He, Kuan Deng, Xiang Wang, Yan Li, Yongdong Zhang, Meng Wang"
        book="arXiv:2002.02126"
        doi=""
        PDF="https://arxiv.org/pdf/2002.02126.pdf"
      ></Ref>
      <Ref
        name="GNN-FiLM: Graph Neural Networks with Feature-wise Linear Modulation"
        link="https://arxiv.org/abs/1906.12192"
        author="Marc Brockschmidt"
        book="arXiv:1906.12192 "
        doi=""
        PDF="https://arxiv.org/pdf/1906.12192"
      ></Ref>
      <Ref
        name="Hyper-Convolution Networks for Biomedical Image Segmentation"
        link="https://arxiv.org/abs/2105.10559"
        author="Tianyu Ma, Adrian V. Dalca, Mert R. Sabuncu"
        book="arXiv:2105.10559"
        doi=""
        PDF="https://arxiv.org/pdf/2105.10559"
      ></Ref>
      <Ref
        name="Network Embedding with Completely-imbalanced Labels"
        link="https://arxiv.org/abs/2007.03545"
        author="Zheng Wang, Xiaojun Ye , Chaokun Wang , Jian Cui, Philip S. Yu"
        book="arXiv:2007.03545"
        doi=""
        PDF="https://arxiv.org/pdf/2007.03545"
      ></Ref>
      <Ref
        name="Convolutional Neural Networks on Graphs with Fast Localized Spectral Filtering"
        link="https://arxiv.org/abs/1606.09375"
        author="Michaël Defferrard, Xavier Bresson, Pierre Vandergheynst"
        book="arXiv:1606.09375 "
        doi=""
        PDF="https://arxiv.org/pdf/1606.09375"
      ></Ref>
      <Ref
        name="Predict then Propagate: Graph Neural Networks meet Personalized PageRank"
        link="https://arxiv.org/abs/1810.05997"
        author="Johannes Gasteiger, Aleksandar Bojchevski, Stephan Günnemann"
        book="arXiv:1810.05997 "
        doi=""
        PDF="https://arxiv.org/pdf/1810.05997"
      ></Ref>
      <Ref
        name="Relational Graph Attention Network for Aspect-based Sentiment Analysis"
        link="https://arxiv.org/abs/2004.12362"
        author="Kai Wang, Weizhou Shen, Yunyi Yang, Xiaojun Quan, Rui Wang"
        book="arXiv:2004.12362"
        doi=""
        PDF="https://arxiv.org/pdf/2004.12362"
      ></Ref>
      <Ref
        name="Robust Layout-aware IE for Visually Rich Documents with Pre-trained Language Models"
        link="https://arxiv.org/abs/2005.11017"
        author="Mengxi Wei, Yifan He, Qiong Zhang"
        book="arXiv:2005.11017 "
        doi=""
        PDF="https://arxiv.org/pdf/2005.11017"
      ></Ref>
      <Ref
        name="TextRGNN: Residual Graph Neural Networks for Text Classification"
        link="https://arxiv.org/abs/2112.15060"
        author="Jiayuan Chen, Boyu Zhang, Yinfei Xu, Meng Wang"
        book="arXiv:2112.15060 "
        doi=" "
        PDF="https://arxiv.org/pdf/2112.15060"
      ></Ref>
      <Ref
        name="Simplifying Graph Convolutional Networks"
        link="https://arxiv.org/abs/1902.07153"
        author="Felix Wu, Tianyi Zhang, Amauri Holanda de Souza Jr., Christopher Fifty, Tao Yu, Kilian Q. Weinberger"
        book="arXiv:1902.07153 "
        doi=""
        PDF="https://arxiv.org/pdf/1902.07153"
      ></Ref>
      <Ref
        name="Generative Invertible Networks (GIN): Pathophysiology-Interpretable Feature Mapping and Virtual Patient Generation"
        link="https://link.springer.com/chapter/10.1007/978-3-030-00928-1_61"
        author="Jialei Chen, Yujia Xie, Kan Wang, Zih Huei Wang, Geet Lahoti, Chuck Zhang, Mani A. Vannan, Ben Wang & Zhen Qian "
        book="MICCAI 2018 doi：10.1007/978-3-030-00928-1_61"
        PDF="https://link.springer.com/content/pdf/10.1007/978-3-030-00928-1.pdf"
      ></Ref>
    </Container>
  );
}

export default inject("store")(observer(Reference));
